import React from "react";
import "./LeadManagementMain.css";
import {
  CheckCircleFilled,
  ArrowRightOutlined,
  AimOutlined,
  SafetyCertificateOutlined,
  CloudOutlined,
  RocketOutlined,
  CheckOutlined,
  ThunderboltFilled,
  FilterOutlined,
  UsergroupAddOutlined,
  BarChartOutlined,
} from "@ant-design/icons";
import leadImage from "../../Asset/lead-management.png";

const featuresLeft = [
  "Lead Capture & Multi-Source Tracking",
  "Automated Lead Assignment & Routing",
  "Lead Qualification & Scoring",
  "Real-Time Pipeline Management",
  "Contact & Prospect Management",
  "Follow-up Reminders & Schedule Alerts",
  "Email & SMS Follow-up Automation",
  "Activity Timeline & Interaction History",
  "Duplicate Lead Detection & Merging",
  "Custom Sales Stages & Statuses",
];

const featuresRight = [
  "Sales Executive Performance Tracking",
  "Bulk Lead Import & Export (Excel/CSV)",
  "Custom Fields & Tags Management",
  "Role-Based Team Access & Permissions",
  "Call Logging & Meeting Notes",
  "Conversion & ROI Analytics Reports",
  "Centralized Communication Log",
  "Cloud Data Security & Backups",
  "Mobile-Ready Web Access",
  "Comprehensive Sales & Lead Reports",
];

const highlights = [
  {
    icon: <FilterOutlined />,
    title: "Pipeline Tracking",
    desc: "Real-time visual sales pipeline",
  },
  {
    icon: <UsergroupAddOutlined />,
    title: "Lead Nurturing",
    desc: "Automated follow-ups & alerts",
  },
  {
    icon: <BarChartOutlined />,
    title: "Conversion ROI",
    desc: "Detailed performance reports",
  },
];

const LeadManagement = () => {
  const handleViewMore = () => {
    window.open("/lead-details", "_blank");
  };

  return (
    <div className="lms-page-light">
      {/* Decorative Background Grid & Glows */}
      <div className="lms-bg-grid"></div>
      <div className="lms-glow-1"></div>
      <div className="lms-glow-2"></div>

      <div className="lms-container">
        
        {/* ═══════ PROFESSIONAL HEADER ═══════ */}
        <div className="lms-header-new">
          <div className="lms-header-top">
            <span className="lms-badge">
              <span className="lms-badge-dot"></span>
              SALES CRM PRODUCT
            </span>
            <span className="lms-version-tag">
              <ThunderboltFilled /> Version 3.5
            </span>
          </div>

          <div className="lms-header-main">
            <div className="lms-header-icon-box">
              <AimOutlined />
            </div>
            <div className="lms-header-text">
              <h1 className="lms-title-new">
                Lead Management <span className="lms-gradient-text">System (LMS)</span>
              </h1>
              <p className="lms-subtitle-new">
                An advanced, modern sales tracking platform designed to capture incoming inquiries, 
                automate sales pipeline stages, streamline executive follow-ups, and accelerate your overall conversion rates.
              </p>
            </div>
          </div>

          {/* Meta Info Pills */}
          <div className="lms-meta-pills">
            <span className="lms-meta-pill">
              <CheckOutlined /> Live Demo Available
            </span>
            <span className="lms-meta-pill">
              <SafetyCertificateOutlined /> Secure & Encrypted
            </span>
            <span className="lms-meta-pill">
              <CloudOutlined /> Cloud-Based Platform
            </span>
            <span className="lms-meta-pill">
              <RocketOutlined /> 24/7 Support Included
            </span>
          </div>
        </div>

        {/* MAIN CONTENT GRID */}
        <div className="lms-main-content">
          
          {/* LEFT — IMAGE & HIGHLIGHTS */}
          <div className="lms-left-col">
            <div className="lms-image-wrapper">
              <div className="lms-image-glow"></div>
              <img
                src={leadImage}
                alt="Lead Management System"
                className="lms-image"
              />
              <div className="lms-image-badge">
                <AimOutlined /> Sales CRM Dashboard
              </div>
            </div>

            {/* Highlights Row */}
            <div className="lms-highlights">
              {highlights.map((item, index) => (
                <div className="lms-highlight-card" key={index}>
                  <div className="lms-highlight-icon">{item.icon}</div>
                  <div className="lms-highlight-text">
                    <h5>{item.title}</h5>
                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT — INFORMATION */}
          <div className="lms-right-col">
            <div className="lms-info-block">
              <p className="lms-para">
                A <strong>Lead Management System (LMS)</strong> is a powerful and essential financial 
                utility engineered to help fast-growing businesses capture, track, nurture, 
                and convert potential prospects into long-term loyal clients with extreme efficiency.
              </p>

              <p className="lms-para">
                It unifies and centralizes incoming leads from multiple channels, automates 
                assignment structures to sales executives, and establishes automated email and SMS 
                reminders — completely removing manual pipelines and maximizing business expansion.
              </p>
            </div>

            {/* FEATURES SECTION */}
            <div className="lms-features-section">
              <h2 className="lms-features-title">
                <span className="title-accent">Key Features</span> & Benefits
              </h2>
              <p className="lms-features-desc">
                Explore our fully-equipped, modern sales pipeline metrics designed to optimize 
                team performance and increase monthly sales revenue.
              </p>

              <div className="lms-features-grid">
                <ul className="lms-features-list">
                  {featuresLeft.map((feature, index) => (
                    <li key={index}>
                      <CheckCircleFilled className="lms-check-icon" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                <ul className="lms-features-list">
                  {featuresRight.map((feature, index) => (
                    <li key={index}>
                      <CheckCircleFilled className="lms-check-icon" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* CTA BUTTON */}
            {/* <div className="lms-cta-wrap">
              <button className="lms-view-btn" onClick={handleViewMore}>
                <span>Explore Full Details</span>
                <ArrowRightOutlined />
              </button>
              <p className="lms-cta-note">
                💡 Get a live demo and technical sales overview
              </p>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadManagement;